import * as types from "./types";
import {
    getGpsDeviceListAxios,
    deleteGpsDeviceAxios,
    postGpsDeviceAxios,
    putGpsDeviceAxios,
    getGpsDeviceByIDAxios
} from "./services";

export async function getGpsDeviceListAction({ commit }) {
    commit(types.LOADING_GPSDEVICE, true);
    try {
        const { data } = await getGpsDeviceListAxios();
        commit(types.GET_GPSDEVICE_LIST, data.result.data);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_GPSDEVICE, false);
    }
}

export async function removeGpsDeviceAction({ commit }, payload) {
    commit(types.LOADING_GPSDEVICE, true);
    try {
        await deleteGpsDeviceAxios(payload);
        commit(types.REMOVE_GPSDEVICE, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_GPSDEVICE, false);
    }
}

export async function addGpsDeviceAction({ commit }, payload) {
    commit(types.LOADING_GPSDEVICE, true);
    try {
        await postGpsDeviceAxios(payload);
        commit(types.ADD_GPSDEVICE, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_GPSDEVICE, false);
    }
}

export async function updateGpsDeviceAction({ commit }, payload) {
    commit(types.LOADING_GPSDEVICE, true);
    try {
        await putGpsDeviceAxios(payload);
        commit(types.UPDATE_GPSDEVICE, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_GPSDEVICE, false);
    }
}


export async function getGpsDeviceByIDAction({commit}, payload) {
    commit(types.LOADING_GPSDEVICE, true);
    try {
        
        const {data} = await getGpsDeviceByIDAxios(payload);
        commit(types.GET_GPSDEVICEBYID, data.result);
    }
    catch(e) {
        throw e;
    }
    finally {
        commit(types.LOADING_GPSDEVICE, false);
    }
   
}